import { HelpOutline } from "@mui/icons-material";
import { Box, Typography, Tooltip, Divider } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const LandscapeNavbar = () => {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      width="1000px"
      alignItems="center"
      py={2}
      // borderBottom={1}
      borderColor="divider"
    >
      <Link to="/home">
        <Box
          height="30px"
          width="110px"
          component="img"
          src="/images/appIcon.png"
          sx={{ cursor: "pointer" }}
        />
      </Link>

      <Box display="flex" flex={1} justifyContent="start">
        <Typography
          component={Link}
          to="#"
          textTransform="none"
          variant="body1"
          color="black"
          sx={{
            textDecoration: "none",
            mx: 1,
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          宿泊予約
        </Typography>

        <Typography
          component={Link}
          to="#"
          textTransform="none"
          variant="body1"
          color="black"
          sx={{
            textDecoration: "none",
            mx: 1,
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          スパ予約
        </Typography>

        <Typography
          component={Link}
          to="#"
          textTransform="none"
          variant="body1"
          color="black"
          sx={{
            textDecoration: "none",
            mx: 1,
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          ギフト
        </Typography>

        <Typography
          component={Link}
          to="#"
          textTransform="none"
          variant="body1"
          color="black"
          sx={{
            textDecoration: "none",
            mx: 1,
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          お取り寄せ
        </Typography>

        <Typography
          component={Link}
          to="#"
          textTransform="none"
          variant="body1"
          color="black"
          sx={{
            textDecoration: "none",
            mx: 1,
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          ふるさと納税
        </Typography>
      </Box>

      <Box display="flex" p={1}>
        <Tooltip title="ヘルプ・お問い合わせ">
          <HelpOutline
            sx={{
              mx: 2,
              cursor: "pointer",
              "&:hover": {
                opacity: "0.6",
              },
            }}
          />
        </Tooltip>
        <Typography
          component={Link}
          to="#"
          textTransform="none"
          variant="body1"
          color="black"
          sx={{
            textDecoration: "none",
            mx: 1,
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          予約確認
        </Typography>
        <Divider flexItem orientation="vertical" sx={{ marginLeft: 2 }} />
      </Box>

      <Box display="flex" p={1}>
        <Typography
          component={Link}
          to="#"
          textTransform="none"
          variant="body1"
          color="black"
          sx={{
            textDecoration: "none",
            mx: 1,
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          会員登録
        </Typography>
        <Typography
          component={Link}
          to="#"
          textTransform="none"
          variant="body1"
          color="black"
          sx={{
            textDecoration: "none",
            mx: 1,
            "&:hover": {
              color: "primary.main",
            },
          }}
        >
          ログイン
        </Typography>
      </Box>
    </Box>
  );
};

export default LandscapeNavbar;
